export default {
  failedQueuedLogs: []
}
